import { css } from 'linaria';

export const serviceDisclaimerWrapper = css`
  display: flex;
  column-gap: 4px;
  padding: 4px 0;
`;

export const signSection = css`
  && {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const signSectionTitle = css`
  && {
    width: 456px;
    margin-bottom: 8px;

    @media (--to-desktop) {
      width: 414px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
